import { render, staticRenderFns } from "./organization-sumary.vue?vue&type=template&id=286ef778&scoped=true&"
import script from "./organization-sumary.vue?vue&type=script&lang=js&"
export * from "./organization-sumary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ef778",
  null
  
)

export default component.exports